export const colors = {
    background: '#F6F6F6',
    text: '#2C2C2C',
    primary: '#2EB6AA',
}
